import {
  AdminSpinner,
  Box,
  Div,
  formatNumber,
  getDashboardSuccessRateDeliveries,
  H3,
  H5,
  Icon,
  lightTheme,
  P,
  Separator,
  SuccessRateEntity,
  VDriveLogo,
  reportError,
} from '@vgrubs/components';
import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';
import { GraphWrapper } from '../../DashboardStyled';
import { dataSuccessRate } from '../../dummyData';

async function getBestPerformingCustomers(
  setSuccessRate: Dispatch<SetStateAction<SuccessRateEntity | null>>,
  setLoading: Dispatch<SetStateAction<boolean>>
) {
  setLoading(true);

  try {
    const { data } = await getDashboardSuccessRateDeliveries();

    setSuccessRate(data.data);
  } catch (error) {
    reportError(error);
  } finally {
    setLoading(false);
  }
}

export const SuccessRateSection = () => {
  const [loading, setLoading] = useState(false);
  const [successRate, setSuccessRate] = useState<SuccessRateEntity | null>(
    null
  );

  useEffect(() => {
    getBestPerformingCustomers(setSuccessRate, setLoading);
  }, []);

  return (
    <Box $p="16px 20px" $relative>
      {loading && <AdminSpinner small absolute creme />}

      <H5 $mb="16">Success Rate</H5>

      <Div $flex $alignCenter>
        <Div $width="40%">
          <Div>
            <P $m="0" $bold>
              Delivered Success
            </P>
            <Div $flex $alignCenter $columnSM $alignStartSM>
              <H3 $color={lightTheme.green} $m="0">
                {formatNumber(successRate?.successPercentage || 0)}%
              </H3>
            </Div>
          </Div>

          <Separator $m="10px 0" />

          <Div>
            <P $m="0" $bold>
              Delivered Failed
            </P>
            <Div $flex $alignCenter $columnSM $alignStartSM>
              <H3 $color={lightTheme.primary} $m="0">
                {formatNumber(successRate?.failurePercentage || 0)}%
              </H3>
            </Div>
          </Div>
        </Div>

        {successRate && (
          <GraphWrapper style={{ position: 'relative' }}>
            <Icon
              style={{
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)',
              }}
              $size={window.innerWidth < 800 ? 60 : 100}
            >
              <VDriveLogo />
            </Icon>
            <ResponsiveContainer width="100%" height="100%">
              <PieChart width={400} height={400}>
                <Pie
                  data={dataSuccessRate(successRate)}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  outerRadius={window.innerWidth < 800 ? 80 : 120}
                  innerRadius={window.innerWidth < 800 ? 30 : 50}
                  fill="#000000"
                  dataKey="value"
                >
                  {dataSuccessRate(successRate).map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.color} />
                  ))}
                </Pie>
              </PieChart>
            </ResponsiveContainer>
          </GraphWrapper>
        )}
      </Div>
    </Box>
  );
};
